import React, { useCallback } from 'react';

import PayloadBuilderJsonActions from './JsonActions';

interface StandalonePayloadActionsProps<TState> {
  state: TState;
  isValid: boolean;
  fullWidth?: boolean;
  serialize: (state: TState) => string;
  getFilename: () => string;
  payloadName: string;
}

export default function StandalonePayloadActions<TState>({
  state,
  isValid,
  fullWidth = false,
  serialize,
  getFilename,
  payloadName,
}: StandalonePayloadActionsProps<TState>) {
  const isPayloadValid = useCallback(() => isValid, [isValid]);

  return (
    <PayloadBuilderJsonActions
      state={state}
      fullWidth={fullWidth}
      isValid={isPayloadValid}
      serialize={serialize}
      getFilename={getFilename}
      disabledTitle="Fix validation errors before copying or downloading"
      copyLabel="Copy JSON"
      copySuccessMessage={`${payloadName} payload copied to clipboard`}
      copyErrorMessage={`Failed to copy ${payloadName} payload`}
    />
  );
}
